import { Button, Form, Offcanvas } from "react-bootstrap";
import { subCategoryServices } from "../../../APIServices/DiscoveryControls/subCategoryServices";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

const UpdateDiscoverySubCategory = ({
  Show,
  Hide,
  Title,
  getDiscoverySubCategoryList,
  discoverySubCategory,
}) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");

  const updatedDiscoverySubCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update sub category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      const userData = {
        subCategoryId: discoverySubCategory?.subCategoryId,
        name,
      };
      const data = await subCategoryServices.updatedDiscoverySubCategory(userData);
      if (data?.statusCode === 200) {
        setName("");
        getDiscoverySubCategoryList();
        Hide();
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (discoverySubCategory) {
      setName(discoverySubCategory.name || "");
    }
  }, [discoverySubCategory]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || loader}
          onClick={updatedDiscoverySubCategory}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Updating..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateDiscoverySubCategory;
